<template>
    <div class="user_content_blcok">
        <div class="user_content_blcok_title">
            企业资质<span><el-button size="mini" style="float:right" type="danger" @click="dialogVisible = true">新增</el-button></span>
        </div>
        <div class="user_content_blcok_line"></div>
        <div class="user_content_block_show">



            <div class="user_address_list">

                
                
                <table width="100%" class="detail-pro-table" v-if="list.length>0">

                <tr>
                    <td class="singular" width="80" style="text-align: center;">ID</td>
                    <td class="singular" width="180">证件类型</td>
                    <td class="singular">证件号码</td>
                    <td class="singular" width="120">开始日期</td>
                    <td class="singular" width="120">结束日期</td>
                    <td class="singular" width="120">状态</td>
                    <td  class="singular" width="146" style="text-align:center">操作</td>
                </tr>
                <tbody  v-if="list.length>0">
                    <tr v-for="(v,k) in list" :key="k">
                        
                            <td style="text-align: center;">{{v.id}}</td>
                            <td>{{v.typeName}}</td>
                            <td>{{v.cardno}}</td>
                            <td>{{v.beginTime | formatTime}}</td>
                            <td>{{v.endTime | formatTime}}</td>
                            <td>
                            <el-tag type="danger" v-if="v.status=='0'">待审核</el-tag>
                            <el-tag type="success" v-else-if="v.status=='1'">已审核</el-tag>
                            <el-tag type="warning" v-else>未通过</el-tag>
                            </td>
                       
                        <td>
            <el-button size="mini"
            type="primary"
             @click="handleUpdate(v.id)"
              >编辑
            </el-button>
            <el-button size="mini"
            type="danger"
            @click="del(v.id)"
              >删除
            </el-button>
</td>

                    </tr>
                    </tbody>
                     </table>

        <div class="home_empty_list" v-else>
            <i class="font iconfont">&#xe600;</i>暂无资质！
        </div>


        <div class="home_fy_block" v-show="list.length>0"  style="margin-top:20px;">
             <el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
        </div>



            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" width="30%" :title="edit_id>0?'编辑资质':'新增资质'"  :close-on-click-modal="false">
            <div class="home_form_main">
               
            <el-form  label-width="100px" ref="info" :model="info">




                    <el-form-item label="证件类别" prop="typeId" :rules="[{required:true,message:'证件类别不能为空',trigger: 'blur' }]">
                        <el-select v-model="info.typeId"  placeholder="请选择类别">
                        <el-option
                            v-for="item in selectMenuList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.code">
                        </el-option>
                        </el-select>

                        
                        </el-form-item>

                <!-- <el-form-item label="证件类别" prop="typeId" :rules="[{required:true,message:'证件类别不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" v-model="info.typeId"></el-input></el-form-item> -->
                <el-form-item label="证件号码" prop="cardno" :rules="[{required:true,message:'证件号码不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" v-model="info.cardno" maxlength="18" show-word-limit></el-input></el-form-item>
                <el-form-item label="开始日期" prop="beginTime" :rules="[{required:true,message:'开始日期不能为空',trigger: 'blur' }]"><el-date-picker v-model="info.beginTime" type="date"  placeholder="选择日期"></el-date-picker></el-form-item>
                <el-form-item label="结束日期" prop="endTime" :rules="[{required:true,message:'开始日期不能为空',trigger: 'blur' }]"><el-date-picker v-model="info.endTime" type="date"  placeholder="选择日期"></el-date-picker></el-form-item>

                <el-form-item label="证件照" prop="imagefile"><el-upload class="avatar-uploader" :action="$api.uploadUserAvatar+'certificate'" :headers="upload_headers" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                        <img v-if="info.imagefile" :src="info.imagefile" class="avatar-upload">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload></el-form-item>
                <!-- <el-form-item>
                    <el-button type="danger" @click="submitForm('info')">提交</el-button>
                    <el-button @click="resetForm('info')">重置</el-button>
                </el-form-item> -->
            </el-form>
               

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="restForm('info')">取 消</el-button>
                <el-button type="danger" @click="submitForm('info')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {formatDate} from '@/utils/date';


export default {
    components: {},
    props: {},
    data() {
      return {
          list: [],
          selectMenuList:[],
          dialogVisible:false,
          edit_id:0,
          filePath:null,
          info:{
              typeId:null,
              cardno:null,
              beginTime:null,
              endTime:null,
              imagefile:null,
              status:0
          },
          type:null,
          total_data:0, // 总条数
          page_size:10,
          current_page:1,
          upload_headers:{},
      };
    },
    computed: {},
    created() {
        this.upload_headers.Authorization = 'Bearer '+localStorage.getItem('token'); // 要保证取到
        this.getList();
        this.getBasedictByType();
        this.filepath();
    },
    filters: {
      formatDate(time) {
        if (time == null || time === '') {
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
      },
      formatTime(time){
        if(time==null||time===''){
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd')
      },
    },
    methods: {
        //附件路径
        filepath:function(){ 
             this.$get(this.$api.filepath,{platId:this.$platId}).then(res=>{
                this.filePath = res.data[0].config;
            });
        },

        handleAvatarSuccess(res) {
            this.info.imagefile = this.filePath + res.data;
            this.$forceUpdate();
        },
        beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 5;
        var isIMG = true;
        if (!isJPG) {
            if (!isPNG) {
            this.$message.error('上传图片只能是 JPG, PNG 格式!');
            isIMG = false;
            }
        }
        if (!isLt2M) {
            this.$message.error('上传图片大小不能超过 5MB!');
        }
        return isIMG && isLt2M;
        },

      httpRequest(option){
        let file = option.file;
        let formData = new FormData();
        formData.append('file', file);
        this.$post(this.$api.uploadUsercertificate,{formData}).then(res=>{
        //uploadGoodsGroupImg(formData).then(res=>{
          if(res.code == 200){
            this.info.imgfile = this.filePath + res.data;
            this.handleAvatarSuccess;
          }else{
            this.$message.error(res.message);
          }
        })
        },


      handleSizeChange(val) {
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.pageNum = val;
        this.getList();
      },
      restForm:function(){
          this.$refs['info'].resetFields()
          this.dialogVisible = false;
      },
        submitForm:function(e){
            let _this = this;
            _this.info.companyId = this.$route.query.id;

            // 验证表单
            this.$refs[e].validate(function(res){
                if(res){
                    //  判断是Add 或者 Edit
                    if(_this.edit_id > 0){
                    _this.$post(_this.$api.editcertificate + _this.edit_id ,_this.info).then(function(res){
                        if(res.code == 200){
                            _this.$message.success("编辑成功");
                            _this.dialogVisible = false;
                            _this.$refs['info'].resetFields(); //关闭弹窗后重置表单
                            _this.getList();
                        }else{
                            _this.$message.error("编辑失败");
                        }
                    });
                        //url = _this.$api.editcertificate + _this.edit_id;
                    }else{
                    // Http 请求
                    _this.$post(_this.$api.addcertificate,_this.info).then(function(res){
                        if(res.code == 200){
                            _this.$message.success("编辑成功");
                            _this.dialogVisible = false;
                            _this.$refs['info'].resetFields(); //关闭弹窗后重置表单
                            _this.getList();
                        }else{
                            _this.$message.error("编辑失败");
                        }
                    });
                    }
                    // Http 请求
                    // _this.$post(url,_this.info).then(function(res){
                    //     if(res.code == 200){
                    //         _this.$message.success("编辑成功");
                    //         _this.dialogVisible = false;
                    //         _this.$refs['info'].resetFields(); //关闭弹窗后重置表单
                    //         _this.getList();
                    //     }else{
                    //         _this.$message.error("编辑失败");
                    //     }
                    // });

                }
            });
        },
        // 分页改变
        current_change:function(e){
            this.current_page = e;
            this.getList();
            this.$scrollTo();
        },

        // getList:function(){
        //     // console.log(this.order_type);
        //     this.$post(this.$api.homeGetUserOrder,{page:this.current_page,order_no:this.order_no,order_type:this.order_type}).then(res=>{
        //         this.order_list = res.data.order_list.data;
        //         this.order_num = res.data.order_num;
        //         this.page_size = res.data.order_list.per_page;
        //         this.total_data = res.data.order_list.total;
        //         this.current_page = res.data.order_list.current_page;
        //     });
        // },
        // 分页改变
        // getList() {
        //     this.listLoading = true;
        //     fetchList(this.listQuery).then(response => {
        //     this.listLoading = false;
        //     this.list = response.data.list;
        //     this.total = response.data.total;
        //     })
        // },
        getList:function(){ 
            if(!this.$isEmpty(this.$route.query.id)){
                this.companyId = this.$route.query.id;
            }
            //console.log(this.companyId);
            this.$get(this.$api.listcertificate+this.companyId,{pageSize:this.page_size,pageNum:this.current_page,platId:this.$platId}).then(res=>{
                this.list = res.data.list;
                this.total = res.data.total;
                this.page_size = res.data.pageSize;
                this.total_data = res.data.total;

            });
        },


        handleUpdate:function(id){
            this.edit_id = id;
            this.dialogVisible = true;
            this.$get(this.$api.certificateid+id).then(res=>{
                this.info = res.data;
                this.info.status = 0
            });
        },


      //证件类别
      getBasedictByType() {
          this.$get(this.$api.getBasedictByType,{type:"certificate_type"}).then(response=>{
        //fetchAllwldwcope(this.listQuery).then(response => {
          this.listLoading = false;
          this.selectMenuList = response.data;
        });
      },



        // 删除处理
        del:function(id){
        this.$confirm('是否要删除资质?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            let _this = this;
            this.$post(this.$api.delcertificate+id, {status:2}).then(function(res){
                if(res.code == 200){
                    _this.getList();
                    return _this.$message.success("删除成功");
                }else{
                    return _this.$message.error("删除失败");
                }
            });
             }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消删除'
          });
          this.getList();
        });
        },
        // close_dialog:function(){
        //     this.edit_id = 0;
        // }
    },

    mounted() {}
};
</script>
<style lang="scss" scoped>
.user_address_list{
    padding-top: 10px;
    ul li{
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid #efefef;
        dl{
            float: left;
            display: block;
            width: 650px;
            dt{
                float: left;
                margin-right: 20px;
                img{
                    border-radius: 50%;
                }
            }
            dd{
                line-height: 20px;
                width: 190px;
                width: 500px;
                float: left;
            }
            dd.address_info{
                color:#999;
                float: left;
                width:100%;
                width: 500px;
            }
        }
        .address_handle{
            color:#666;
            float:right;
            line-height: 40px;
            span{
                margin: 0 10px; 
                i{
                    margin-right: 10px;
                }
                
            }
            span:hover{
                color:#409EFF;
            }
            span.red{
                color:#409EFF;
            }
        }
    }
}

.pagination-container {
    display: inline-block;
    margin-top: 20px;
}
.detail-pro-table td{text-indent: 0px !important;}
</style>